<template>
  <div class="footer">
    <img src="@/assets/img/home/uaes-slogan.png" class="slogan" alt="" width="" height=""/>
    <div class="concealDiv">
      <div>
        <img style="vertical-align: middle;" src="@/assets/img/home/footer_icon _location.png" alt="" width="" height=""/>
        <span style="font-size: 14px; color: #2F374B;vertical-align: middle;padding-left:5px">中国上海浦东新区榕桥路555号</span>
      </div>
      <div>
        <img style="vertical-align: middle;" src="@/assets/img/home/footer_icon _mail.png" alt="" width="" height=""/>
        <span style="font-size: 14px;color: #2F374B;vertical-align: middle;padding-left:5px">helpusp@uaes.com</span>
      </div>
    </div>
    <div class="concealDiv">
      <div>
        <a href="https://beian.miit.gov.cn" target="_blank" style="margin-top:14px;color: #4d78ff;text-align: center;font-size: 14px;text-decoration:none;">沪ICP备15019161号-2</a>
      </div>
      <div>
        <a href="/privacyProtocol.html" target="_blank" style="margin-top:14px;color: #4d78ff;text-align: center;font-size: 14px;text-decoration:none;">隐私政策</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.footer{
  background: #DBDBDB;
  text-align: center;
  margin-top:134px;
  padding-top:48px;
  padding-bottom:22px;
  .slogan {
    width: 25%;
  }
}
.concealDiv{
  padding-top: 15px;
  display: flex;
  justify-content: center;
}
.concealDiv div{
  padding: 0 20px;
  a{
    color: #5a5a5a !important;
  }
}
</style>
